import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AppStoreButton, ButtonsContainer, GooglePlayButton } from "react-mobile-app-button";
import { Smartphone } from "lucide-react";

interface MobileAppDownloadPromptProps {
  open: boolean;
}

export const MobileAppDownloadPrompt = ({ open }: MobileAppDownloadPromptProps) => {
  const [isDismissed, setIsDismissed] = useState(false);
  const APP_STORE_URL = import.meta.env.VITE_APP_STORE_URL;
  const PLAY_STORE_URL = import.meta.env.VITE_PLAY_STORE_URL;

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) setIsDismissed(true);
  };

  return (
    <Dialog open={open && !isDismissed} onOpenChange={handleOpenChange}>
      <DialogContent
        className="max-w-[90vw] rounded-2xl sm:max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="space-y-4 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
            <Smartphone className="h-8 w-8 text-gray-700" />
          </div>
          <DialogTitle className="text-xl font-semibold">Download Our Mobile App</DialogTitle>
          <DialogDescription className="text-base text-gray-600">
            For the best experience on your mobile device, please use our dedicated mobile app.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 flex justify-center">
          <ButtonsContainer gap={12} direction="column">
            <AppStoreButton
              url={APP_STORE_URL}
              theme="dark"
              className="[container-type:inline-size] [&_span:first-of-type]:!text-[7cqw] [&_span:last-of-type]:!text-[11cqw]"
            />
            <GooglePlayButton
              url={PLAY_STORE_URL}
              theme="dark"
              className="[container-type:inline-size] [&_span:first-of-type]:!text-[7cqw] [&_span:last-of-type]:!text-[11cqw]"
            />
          </ButtonsContainer>
        </div>

        <p className="mt-4 text-center text-xs text-gray-400">
          Our mobile web experience has limited functionality.
          <br />
          The native app provides the full Rebuild experience.
        </p>
      </DialogContent>
    </Dialog>
  );
};
